export const callFlowQueryKeys = {
    all: ["call-flow"] as const,
    byCompanyId: (companyId: number) => ["call-flow", companyId] as const,
}